import Support from './Support'

export default Support
// eslint-disable-next-line import/export
export * from './Support'
